import { Btn, H6, H2, H3, LI, P, UL, H4 } from '../../../../AbstractElements';
import { MarginBottom, Subscribe, month } from '../../../../Constant';
import React, { Fragment, useEffect, useState, useRef } from 'react';
import { Col, CardBody, Card, Row } from 'reactstrap';
import { getMasterDataToken, postMasterToken } from '../../../../Utils/restUtils';
import { getPackageDet, postSubscription } from '../../../../CommonUrl';
import { useNavigate } from 'react-router';
import HandleHomePageError from '../../../Common/ErrorImport/SignError';
import Transparentspinner from '../../../Common/Loader/Transparentspinner';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { setSubStatus, setSubscriptionDetails } from '../../../../Redux/Reducer';

const Standards = (props) => {
    const priceDetails = props.details;
    const authState = props.auth;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setloading] = useState(false);
    const [color, setcolor] = useState('');

    const containerRef = useRef(null);
    const [isOverflow, setIsOverflow] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {

        if (priceDetails?.days_left >= -10 && priceDetails?.days_left <= 1) {
            setcolor('red')
        } else if (priceDetails?.days_left <= 10) {
            setcolor('orange')
        } else {
            setcolor('blue')
        }
    }, [])

    const checkOverflow = () => {
        if (containerRef.current) {
            const { scrollWidth, clientWidth } = containerRef.current;
            setIsOverflow(scrollWidth > clientWidth);
        }
    };

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const resizeObserver = new ResizeObserver(() => {
            checkOverflow();
        });
        resizeObserver.observe(container);
        checkOverflow();

        return () => {
            resizeObserver.disconnect();
        };
    }, [priceDetails?.packages]);

    useEffect(() => {
        const container = containerRef.current;
        if (!container || !isOverflow) return;

        let intervalId;
        let direction = 1; // 1 = scroll right, -1 = scroll left

        const startScrolling = () => {
            intervalId = setInterval(() => {
                if (isHovered) return;

                const maxScroll = container.scrollWidth - container.clientWidth;
                if (maxScroll <= 0) return;

                const currentScroll = container.scrollLeft;

                if (currentScroll >= maxScroll - 1 && direction === 1) {
                    direction = -1;
                } else if (currentScroll <= 0 && direction === -1) {
                    direction = 1;
                }

                container.scrollLeft += direction;
            }, 35);
        };

        startScrolling();

        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [isOverflow, isHovered]);

    const scroll = (dir) => {
        if (containerRef.current) {
            const scrollAmount = 380;
            containerRef.current.scrollBy({
                left: dir === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth'
            });
        }
    };

    const submitSubscription = async (item) => {
        setloading(true);
        const integerNumber = Number(item.price)
        if (integerNumber === 0) {
            const postRequest = { package_id: item.id, industry_type_id: authState.industryId, company_id: props.companyId, company: '' }
            const response = await postMasterToken(postSubscription, postRequest);
            if (response.status === 200) {
                const response = await getMasterDataToken(getPackageDet);
                if (response.status === true) {
                    const packagetDetails = { packageName: response.data.package_name, packageExp: response.data.package_expire_in }
                    dispatch(setSubscriptionDetails(packagetDetails));
                    dispatch(setSubStatus(packagetDetails));
                    if(authState.subStatus !== null || authState.subStatus.length !== 0){
                    navigate(`${process.env.PUBLIC_URL}/dashboard/default`);
                    }
                    toast.success(response.data.message);
                }
                else {
                    HandleHomePageError(navigate, response.status)
                    setloading(false)

                }
                setloading(false)
            }
            else {
                HandleHomePageError(navigate, response.status)
            }
        } else {
            navigate('/applyCoupon', { state: { package_id: item, company_id: props.companyId } });
        }
        setloading(false);
    }

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <CardBody className='pt-2'>
                {priceDetails?.current_plan != 'None' && (
                    <div>
                        <div className={`mb-3 p-3 text-white bg-subscription-${color} `} >
                            {props.upgradeText && <div><strong>{props.upgradeText}</strong><br/></div>}
                            <strong>Note:</strong> Your current package ends on <span className="note-date">{priceDetails?.end_date ?? ''}</span>.{priceDetails?.days_left > 0 && <span className="note-days-left"> Only {priceDetails?.days_left ?? ''} days left.</span>}
                        </div>
                    </div>
                )}
                <div 
                    className="pricing-carousel-wrapper"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    {isOverflow && (
                        <button 
                            type="button" 
                            className="pricing-carousel-btn prev" 
                            onClick={() => scroll('left')}
                            aria-label="Previous"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="15 18 9 12 15 6"></polyline>
                            </svg>
                        </button>
                    )}
                    
                    <div 
                        className="pricing-carousel-container" 
                        ref={containerRef}
                    >
                        <Row className={`pricing-content pricing-col flex-nowrap m-0 ${isOverflow ? '' : 'justify-content-center'}`}>
                            {
                                priceDetails?.packages.map((item, index) => {
                                    const integerNumber = item.price;
                                    const isPopular = index === 2 || item.name.toLowerCase() === 'growth' || item.name.toLowerCase() === 'premium';
                                    const hasFreeTrialDays = item.free_trial_days !== undefined && item.free_trial_days !== null && Number(item.free_trial_days) !== 0;
                                    const displayDuration = hasFreeTrialDays ? `${item.free_trial_days} days` : item.duration;
                                    return (
                                        <Col md='4' className="mb-4" key={index}>
                                            <Card className={`pricing-new-card  ${isPopular ? 'popular-theme' : ''}`}>
                                                {/* {isPopular && (
                                                    <div className="most-popular-ribbon">
                                                        <svg viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
                                                        MOST POPULAR
                                                    </div>
                                                )} */}
                                                <div className="pricing-header">
                                                    <H2>{item.name}</H2>
                                                    <div className="subtitle">{item.description}</div>
                                                    <div className="price-display">
                                                        {/* {integerNumber !== 0 && <span className="original-price">{item.currency  }{item.price}</span>} */}
                                                        <H3>{item.currency    } {item.min_price}</H3>
                                                        <span className="duration">/{displayDuration}</span>
                                                    </div>
                                                    {integerNumber !== 0 && (
                                                        <div className="setup-cost">
                                                            Setup Cost <span className="setup-cost-amount">{item.currency} {item.setup_cost}</span>
                                                        </div>
                                                    )}
                                                    {integerNumber === 0 && <div className="setup-cost">No credit card required</div>}
                                                </div>
                                                
                                                <div className="connection-box">
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path></svg>
                                                    <span>{integerNumber === 0 ? `Max connections ${item.max_connection}` : `Up to ${item.min_connection} connections - ${item.currency} ${item.price}/extra`}</span>
                                                </div>
                                                
                                                <div className="whats-included">WHAT'S INCLUDED</div>
                                                
                                                {(() => {
                                                    const sections = [];
                                                    let currentSection = { title: null, items: [] };

                                                    if (item.features) {
                                                        item.features.split('\n').forEach(feature => {
                                                            if (!feature.trim()) return;
                                                            if (feature.startsWith('**')) {
                                                                if (currentSection.items.length > 0 || currentSection.title) {
                                                                    sections.push(currentSection);
                                                                }
                                                                currentSection = { title: feature.replace('**', '').trim(), items: [] };
                                                            } else {
                                                                currentSection.items.push(feature);
                                                            }
                                                        });
                                                        if (currentSection.items.length > 0 || currentSection.title) {
                                                            sections.push(currentSection);
                                                        }
                                                    }

                                                    return sections.map((section, sIndex) => (
                                                        <React.Fragment key={`section-${sIndex}`}>
                                                            {section.title && (
                                                                <>
                                                                    <hr style={{ margin: '5px 0 10px 0', borderColor: '#e2e8f0' }} />
                                                                    <div className="whats-included" style={{marginTop: '5px'}}>{section.title.toUpperCase()}</div>
                                                                </>
                                                            )}
                                                            <ul className="pricing-features" style={{ marginBottom: sIndex < sections.length - 1 ? '0' : 'inherit' }}>
                                                                {section.items.map((feature, fIndex) => (
                                                                    <li key={`feature-${sIndex}-${fIndex}`}>
                                                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                                                        <span>{feature}</span>
                                                                    </li>
                                                                ))}
                                                                {sIndex === 0 && (
                                                                    <li>
                                                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                                                        <span>Duration: {displayDuration} </span>
                                                                    </li>
                                                                )}
                                                            </ul>
                                                        </React.Fragment>
                                                    ));
                                                })()}
                                                
                                                <div className="pricing-footer">
                                                    <button className="btn-pricing" onClick={() => submitSubscription(item)} disabled={priceDetails?.current_plan != 'Free Trial' && priceDetails?.days_left >= 5}>{integerNumber === 0 ? 'Start Free Trial' : Subscribe}</button>
                                                </div>
                                            </Card>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </div>
                    {isOverflow && (
                        <button 
                            type="button" 
                            className="pricing-carousel-btn next" 
                            onClick={() => scroll('right')}
                            aria-label="Next"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </button>
                    )}
                </div>
            </CardBody>
        </Fragment>
    );
};

export default Standards;
